import { ThemeData } from "../../api/personalization/theme/data";
import CButton from "../../components/CButton";
import CStack from "../../components/CStack";

type ThemeListProps = {
  themes: ThemeData[] | null;
  onClick: (theme: ThemeData) => void;
};

const ThemeList: React.FC<ThemeListProps> = ({ onClick, themes }) => {
  if (!Array.isArray(themes) || themes.length === 0) {
    return <CStack header="Themes">No themes available.</CStack>;
  }

  return (
    <CStack header="Themes">
      {themes.map((theme, idx) => (
        <CButton key={theme.Id || idx} onClick={() => onClick(theme)}>
          <div className="list1">{theme.Code}</div>
          <div className="list1-sub">{theme.Description}</div>
        </CButton>
      ))}
    </CStack>
  );
};

export default ThemeList;
